import { connect } from 'react-redux';
//
import PortfolioDefaultView from 'pages/portfolio/default-view/PortfolioDefaultView';
import { IStoreState } from 'store';
import { IPortfolioWithDetails } from 'store/portfolio/types';
import { IStatusFieldOption } from 'store/field-options/types';
import { getStatusesForLegend } from 'pages/portfolio/selectors';
import { removePortfolioDealAndId } from 'store/portfolio/actions';

export interface IPortfolioDefaultViewStateProps {
  availableStatuses: IStatusFieldOption[];
  portfolioDeals: IPortfolioWithDetails[];
}

export interface IParetoDefaultViewDispatchProps {
  removePortfolioDealAndId: (dealName: string, dealId: string) => void;
}

export type TPortfolioDefaultViewProps = IPortfolioDefaultViewStateProps & IParetoDefaultViewDispatchProps;

const mapStateToProps = (state: IStoreState): IPortfolioDefaultViewStateProps => ({
  portfolioDeals: state.pareto.portfolioDeals,
  availableStatuses: getStatusesForLegend(state),
});

const mapDispatchToProps = {
  removePortfolioDealAndId,
};

export default connect(mapStateToProps, mapDispatchToProps)(PortfolioDefaultView);
